import { ChangeDetectionStrategy, Component, computed, input, output, signal, effect } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Component({
    selector: 'ca-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatSlideToggle]
})
export class ToggleComponent {
    public value = input<boolean>(false);
    public disabled = input<boolean>(false);
    public valueChanged = output<boolean>();

    public hideIcon = signal(true);

    setHideIcon = effect(() => {
        this.hideIcon.set(!this.value());
    });
}
